import React from 'react';
import { Link } from 'react-router-dom';
import './EmailDashboard.css';

const EmailDashboard = () => {
  return (
    <div className="container py-4">
      <h2 className="mb-4 text-primary">📬 Admin Email Dashboard</h2>

      <div className="d-flex flex-wrap justify-content-center gap-3">
        <Link to="/admin/email/summary" className="btn btn-primary small-box-btn">
          📊 Summary
        </Link>
        <Link to="/admin/email/send" className="btn btn-success small-box-btn">
          📬 Send Email
        </Link>
        <Link to="/admin/email/logs" className="btn btn-secondary small-box-btn">
          📑 Logs
        </Link>
        <Link to="/admin/email/unsubscribed" className="btn btn-danger small-box-btn">
          🚫 Unsubscribed Users
        </Link>
        <Link to="/admin/email/stats-daily" className="btn btn-info small-box-btn">
          📈 Daily Email Stats
        </Link>

        {/* ✅ New button for Registered Users */}
   <Link to="/admin/email/all-users" className="btn btn-warning small-box-btn">
  👥 All Users
</Link>
      </div>
    </div>
  );
};

export default EmailDashboard;
